import { render, staticRenderFns } from "./Passages.vue?vue&type=template&id=1c563174&scoped=true&"
import script from "./Passages.vue?vue&type=script&lang=js&"
export * from "./Passages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c563174",
  null
  
)

export default component.exports